export const getCookieValue = (key) => {
    let b = !((typeof document !== 'undefined') && document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)") === null) ? (typeof document !== 'undefined') ? document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)") : '' : '';
    // console.log(b)
    return Array.isArray(b) ? b.pop() : null
} 
